/**
 * Shadow Notes Admin API
 *
 * Wraps the generated shadow-notes endpoints with cache tags and
 * re-exports hooks with user-friendly names.
 */

import { enhancedApi } from '@store/generated/shadow-notes';

const SHADOW_NOTE_TAG = 'ShadowNote' as const;

export const shadowNotesApi = enhancedApi.enhanceEndpoints({
  addTagTypes: [SHADOW_NOTE_TAG],
  endpoints: {
    getV2AdminShadowNotes: {
      providesTags: (result) =>
        result?.shadow_notes
          ? [
              ...result.shadow_notes
                .filter((n): n is typeof n & { shadow_note_id: string } => !!n.shadow_note_id)
                .map((n) => ({ type: SHADOW_NOTE_TAG as typeof SHADOW_NOTE_TAG, id: n.shadow_note_id })),
              { type: SHADOW_NOTE_TAG, id: 'LIST' },
            ]
          : [{ type: SHADOW_NOTE_TAG, id: 'LIST' }],
    },
    postV2AdminShadowNotes: {
      invalidatesTags: [{ type: SHADOW_NOTE_TAG, id: 'LIST' }],
    },
    getV2AdminShadowNotesByShadowNoteId: {
      providesTags: (_result, _error, { shadowNoteId }) => [
        { type: SHADOW_NOTE_TAG, id: shadowNoteId },
      ],
    },
    deleteV2AdminShadowNotesByShadowNoteId: {
      invalidatesTags: (_result, _error, { shadowNoteId }) => [
        { type: SHADOW_NOTE_TAG, id: shadowNoteId },
        { type: SHADOW_NOTE_TAG, id: 'LIST' },
      ],
    },
  },
});

// Re-export hooks with user-friendly names
export const {
  useGetV2AdminShadowNotesQuery: useListShadowNotesQuery,
  usePostV2AdminShadowNotesMutation: useCreateShadowNoteMutation,
  useGetV2AdminShadowNotesByShadowNoteIdQuery: useGetShadowNoteQuery,
  useDeleteV2AdminShadowNotesByShadowNoteIdMutation: useDeleteShadowNoteMutation,
} = shadowNotesApi;

// Re-export generated types for convenience
export type {
  CreateShadowNoteRequest,
  GetV2AdminShadowNotesApiArg as ListShadowNotesParams,
  ShadowNoteDeleteResponse,
  ShadowNoteListResponse,
  ShadowNoteResponse,
} from '@store/generated/shadow-notes';
